import React, { useContext, useEffect } from 'react'
import { Divider } from '@material-ui/core'

import ItemEcommerce from '~/components/Ecommerce/ItemEcommerce'
import track from '~/track'
import { EcommerceContext } from './DrawerEcommerce'
import { OnlineStoreContext } from '../OnlineStorePage'

function storeHadSeen(store) {
  track('lojaOnlineListada', {
    category: 'LojasOnline',
    name: store?.name,
  })
}

export default function ListEcommerce({ configEcommerce, openEcommerce, handleLogger }) {
  const ecommerceContext = useContext(EcommerceContext)
  const onlineStoreContext = useContext(OnlineStoreContext)

  const context = ecommerceContext ? ecommerceContext : onlineStoreContext

  const {
    hasStoresFeatured,
    hasStoresManuals,
    isViewLimited,
    isViewOnlyStoresManuals,
    isViewOnlyStoresFeatured,
    showProductValue,
    storesManuals,
    dataOffersFeatured,
    filteredOffers,
  } = context

  useEffect(() => {
    if (!isViewLimited || (isViewOnlyStoresManuals && isViewOnlyStoresFeatured)) {
      hasStoresManuals && storesManuals.map(storeHadSeen)
      hasStoresFeatured && dataOffersFeatured.map(storeHadSeen)
    } else {
      isViewOnlyStoresManuals && hasStoresManuals && storesManuals.map(storeHadSeen)
      isViewOnlyStoresFeatured && hasStoresFeatured && dataOffersFeatured.map(storeHadSeen)
    }

    !isViewLimited && filteredOffers?.map(storeHadSeen)
  }, [])

  return (
    <>
      {!isViewLimited || (isViewOnlyStoresManuals && isViewOnlyStoresFeatured) ? (
        <>
          {hasStoresManuals &&
            storesManuals
              .filter((store) =>
                hasStoresFeatured
                  ? !dataOffersFeatured.some((dof) => dof?.name?.toLowerCase() === store.name.toLowerCase())
                  : true,
              )
              .map((store, index, arr) => (
                <ItemEcommerce
                  isManually
                  key={`${store.name}-${index}`}
                  store={store}
                  product={openEcommerce}
                  handleLogger={handleLogger}
                  divider={index !== arr.length - 1}
                  configEcommerce={configEcommerce}
                />
              ))}

          {hasStoresManuals && (
            <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE', listStyleType: 'none' }} />
          )}

          {hasStoresFeatured && (
            <>
              {dataOffersFeatured?.map((store, index, arr) => (
                <ItemEcommerce
                  key={`${store.name}-${index}`}
                  store={store}
                  product={openEcommerce}
                  showValue={showProductValue}
                  handleLogger={handleLogger}
                  divider={index !== arr.length - 1}
                  configEcommerce={configEcommerce}
                />
              ))}
            </>
          )}
        </>
      ) : (
        <>
          {isViewOnlyStoresManuals &&
            hasStoresManuals &&
            storesManuals.map((store, index, arr) => (
              <ItemEcommerce
                isManually
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
                configEcommerce={configEcommerce}
              />
            ))}

          {isViewOnlyStoresFeatured &&
            hasStoresFeatured &&
            dataOffersFeatured?.map((store, index, arr) => (
              <ItemEcommerce
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                showValue={showProductValue}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
                configEcommerce={configEcommerce}
              />
            ))}
        </>
      )}

      {!isViewLimited && (
        <>
          {(hasStoresFeatured || hasStoresManuals) && (
            <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE', listStyleType: 'none' }} />
          )}

          {filteredOffers
            ?.sort((a, b) => a?.price - b?.price)
            ?.map((store, index, arr) => (
              <ItemEcommerce
                key={`${store.name}-${index}`}
                store={store}
                product={openEcommerce}
                showValue={showProductValue}
                handleLogger={handleLogger}
                divider={index !== arr.length - 1}
                configEcommerce={configEcommerce}
              />
            ))}
        </>
      )}
    </>
  )
}
